import axios from "axios";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { ReactSVG } from "react-svg";
import { toast } from "react-toastify";
import {
  getBaseDataInfoFromLocaleStorage,
  saveBaseDataInfoToLocaleStorage,
} from "../../../utils/base-data";
import { getBaseDataLawyer } from "../../../redux/action/baseData/baseAction";
import { SET_SUCCESS_BASEDATA } from "../../../redux/action/baseData/baseType";
import { apiKey } from "../../../redux/store";
import { useNavigate } from "react-router-dom";

export function purchaseSubscription(sku, payload, last_purchase_token) {
  if (!window.AndroidBilling) {
    window.alert("AndroidBilling not available");
    return;
  }
  const doPurchase = () => {
    window.AndroidBilling.purchaseSubscription(sku, payload);
  };
  if (last_purchase_token) {
    window.onConsumePurchaseResult = function (success, message, token) {
      if (success) {
        console.log("Consume successful for token:", token);
      } else {
        console.warn("Consume failed for token:", token, "Message:", message);
      }
      doPurchase();
      window.onConsumePurchaseResult = null;
    };
    window.AndroidBilling.consumePurchase(last_purchase_token);
  } else {
    doPurchase();
  }
}

// export function purchaseSubscription(sku, payload, last_purchase_token) {
//   window.alert("Last Purchase Token:\n" + last_purchase_token);
//   if (!window.AndroidBilling) {
//     window.alert("AndroidBilling not available");
//     return;
//   }
//   const doPurchase = () => {
//     window.AndroidBilling.purchaseSubscription(sku, payload);
//   };
//   if (last_purchase_token) {
//     window.onConsumePurchaseResult = function (success, message, token) {
//       window.alert(
//         "Consume Purchase Result\n\n" +
//         "Success: " + success + "\n" +
//         "Message: " + message + "\n" +
//         "Token: " + token
//       );

//       if (success) {
//         console.log("Consume successful for token:", token);
//       } else {
//         console.warn(
//           "Consume failed for token:",
//           token,
//           "Message:",
//           message
//         );
//       }
//       window.alert("Consume finished → starting new purchase");
//       doPurchase();
//       window.onConsumePurchaseResult = null;
//     };

//     window.alert("Calling consumePurchase ...");

//     window.AndroidBilling.consumePurchase(last_purchase_token);
//   } else {
//     window.alert("No previous token → starting purchase directly");
//     doPurchase();
//   }
// }

export default function BazaarBilling({ bazaar }) {
  // window.alert(JSON.stringify(bazaar))
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.baseData.info?.profile?.id);
  const loaded = useSelector((state) => state.baseData.loaded);
  const [cookies] = useCookies(["authToken"]);
  const navigate = useNavigate();
  /* اتصال به بازار */
  useEffect(() => {
    window.onBazaarConnectionResult = (success) => {
      if (!success) {
        toast.error("اتصال به کافه‌بازار ناموفق بود");
      }
    };
    window.AndroidBilling.connect();
  }, []);

  useEffect(() => {
    window.onPurchaseResult = async (
      success,
      message,
      purchaseJson,
      signature,
    ) => {
      let finalPurchaseData = null;
      try {
        let purchase = null;
        if (purchaseJson) {
          if (typeof purchaseJson === "string") {
            purchase = JSON.parse(purchaseJson);
          } else {
            purchase = purchaseJson;
          }
        }
        finalPurchaseData = {
          success,
          transaction_id: bazaar.transaction_id,
          orderId: purchase?.orderId || null,
          packageName: purchase?.packageName || null,
          productId: purchase?.productId || bazaar.plan_code,
          purchaseTime: purchase?.purchaseTime || null,
          purchaseState: success ? 1 : 0,
          developerPayload: bazaar.developerPayload,
          purchaseToken: purchase?.purchaseToken || null,
          signature: signature || null,
        };

        const config = {
          headers: {
            "Auth-Token": cookies?.authToken,
            "X-Auth-Token": cookies?.authToken,
          },
          timeout: 15000,
        };

        const { data } = await axios.post(
          `${apiKey}wallet/callback_bazaar`,
          finalPurchaseData,
          config,
        );

        if (success && data?.success) {
          toast.success(data.message || "خرید با موفقیت تایید شد ✅");
        } else if (!success) {
          toast.error("پرداخت توسط کاربر لغو شد یا ناموفق بود ❌");
        } else {
          toast.error(data.message || "تایید خرید ناموفق بود ❌");
        }
        bazaar.wallet ? navigate("/wallet") : navigate("/plans");
      } catch (error) {
        console.error("Bazaar verify error:", error);
        toast.error(error?.response?.data?.message || "خطا در ارتباط با سرور");
        bazaar.wallet ? navigate("/wallet") : navigate("/plans");
      }
    };
    window.AndroidBilling?.getPurchases();
  }, [bazaar.plan_code, cookies?.authToken]);

  useEffect(() => {
    if (!loaded) fetchBaseData();
  }, [loaded]);

  const fetchBaseData = async () => {
    const baseData = getBaseDataInfoFromLocaleStorage();

    if (baseData) {
      dispatch({ type: SET_SUCCESS_BASEDATA, payload: baseData });
      return;
    }

    const data = await dispatch(await getBaseDataLawyer(cookies.authToken));
    if (data) saveBaseDataInfoToLocaleStorage(data);
  };

  return (
    <li>
      <button
        onClick={() =>
          purchaseSubscription(
            bazaar.plan_code,
            `userId=${userId}`,
            bazaar.last_purchase_token,
          )
        }
        className="group bg-white h-20 rounded-xl w-full p-4 shadow-custom-md flex items-center justify-between flex-wrap gap-4 hover:shadow-custom-xl duration-500"
      >
        <div className="flex items-center gap-4">
          <img
            className="w-12 flex-shrink-0"
            src={`${process.env.PUBLIC_URL}/assets/images/pictures/payment/bazaar.png`}
            alt="payment icon bazaar"
          />
          <span className="font-medium">پرداخت از کافه‌بازار</span>
        </div>

        <ReactSVG
          className="w-4 -rotate-90 group-hover:scale-110 duration-500"
          src={`${process.env.PUBLIC_URL}/assets/images/icons/up.svg`}
        />
      </button>
    </li>
  );
}
